import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseHref } from "service/api";
type SiteResponse = {
  logo: string;
  smallLogo: string;
  siteMainEmail: string;
  mainUrl: string;
  name: string;
  privacyAndPolicyUrl: string;
  termsAndConditionsUrl: string;
  frontWalletSecondaryLogo: string;
  frontWalletAuthPageColor: string;
  registrationType: string;
  favicon: string;
  btcManualSellAddress: string | null;
  ethErc20ManualSellAddress: string | null;
  trxTrc20ManualSellAddress: string | null;
};
export const siteApi = createApi({
  reducerPath: "siteApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseHref}/get-site`,
    credentials: "include",
  }),
  tagTypes: ["Site"],
  endpoints: (builder) => ({
    getSite: builder.query<SiteResponse, void>({
      query: () => ``,
    }),
  }),
});
export const { useGetSiteQuery } = siteApi;
